/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 全屏预览弹窗（根 index 挂载，由 Context 驱动显隐与数据）
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-01-26
 */

import React from 'react'
import { Modal } from 'antd'
import type { PhotoItem } from '../../context/WatermarkBatchContext'
import './FullscreenPreviewModal.scss'

export interface FullscreenPreviewModalProps {
  visible: boolean
  imageList: string[]
  index: number
  photoType: 'success' | 'failed' | null
  failedPhotos: PhotoItem[]
  onClose: () => void
}

const FullscreenPreviewModal: React.FC<FullscreenPreviewModalProps> = ({
  visible,
  imageList,
  index,
  photoType,
  failedPhotos,
  onClose
}) => {
  const currentSrc = imageList[index]
  const currentFailed = photoType === 'failed' && failedPhotos[index]

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      closable
      mask={{ closable: true }}
      width="100%"
      style={{ top: 0, padding: 0 }}
      styles={{ body: { padding: 0, height: '100vh', background: '#000' } }}
      className="fullscreen-preview-modal"
      destroyOnHidden
    >
      <div className="preview-container" onClick={onClose}>
        {currentSrc && (
          <img
            src={currentSrc}
            alt="预览"
            style={{
              maxWidth: '100%',
              maxHeight: '100vh',
              objectFit: 'contain',
              display: 'block',
              margin: '0 auto'
            }}
            onClick={onClose}
          />
        )}
        {currentFailed && (
          <div className="preview-failure-reason">
            {currentFailed.errorMsg ||
              currentFailed.reason ||
              '处理失败，请重试'}
          </div>
        )}
      </div>
    </Modal>
  )
}

export default FullscreenPreviewModal
